import { render } from "./new-delivery-address.vue?vue&type=template&id=3b96b814"
import script from "./new-delivery-address.vue?vue&type=script&lang=js"
export * from "./new-delivery-address.vue?vue&type=script&lang=js"

import "./new-delivery-address.vue?vue&type=style&index=0&id=3b96b814&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__